let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("buWU3")).then(() => parcelRequire('9pvx2'));